import { Asset, Theme, Container } from 'shared/models';

export const Actions = {
    SHOW_EDITOR: 'SHOW_EDITOR',
    EDIT_THEME: 'EDIT_THEME',
    HIDE_EDITOR: 'HIDE_EDITOR',
    HIDE_EDITOR_REQUEST: 'HIDE_EDITOR_REQUEST',

    SAVE_THEME_REQUEST: 'SAVE_THEME_REQUEST',
    SAVE_THEME_SUCCESS: 'SAVE_THEME_SUCCESS',
    SAVE_THEME_FAILURE: 'SAVE_THEME_FAILURE',
    DISMISS_ERROR: 'DISMISS_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    DISMISS_PUBLISH_PENDING: 'DISMISS_PUBLISH_PENDING',

    SET_ACTIVE_CONTAINER: 'SET_ACTIVE_CONTAINER',
    SET_ACTIVE_ASSET: 'SET_ACTIVE_ASSET',

    SET_ZOOM_LEVEL: 'SET_ZOOM_LEVEL',
    SET_FIT_ZOOM: 'SET_FIT_ZOOM',

    SET_EDITOR_THEME_PROPERTIES: 'SET_EDITOR_THEME_PROPERTIES',

    SET_ACTIVE_REGION: 'SET_ACTIVE_REGION',
    CLEAR_ACTIVE_REGION: 'CLEAR_ACTIVE_REGION',

    PREVIEW_NEW_CONTAINER: 'PREVIEW_NEW_CONTAINER',
    ADD_NEW_CONTAINER: 'ADD_NEW_CONTAINER',
    UPDATE_CONTAINER: 'UPDATE_CONTAINER',
    DELETE_CONTAINER: 'DELETE_CONTAINER',
    MOVE_CONTAINER_FORWARD: 'MOVE_CONTAINER_FORWARD',
    MOVE_CONTAINER_BACKWARD: 'MOVE_CONTAINER_BACKWARD',

    UPLOAD_ASSET_REQUEST: 'UPLOAD_ASSET_REQUEST',
    UPLOAD_ASSET_PROGRESS: 'UPLOAD_ASSET_PROGRESS',
    UPLOAD_ASSET_SUCCESS: 'UPLOAD_ASSET_SUCCESS',
    UPLOAD_ASSET_FAILURE: 'UPLOAD_ASSET_FAILURE',
    CLEAR_UPLOAD_ASSET_PROGRESS: 'CLEAR_UPLOAD_ASSET_PROGRESS',

    ADD_NEW_ASSET: 'ADD_NEW_ASSET',
    UPDATE_ASSET: 'UPDATE_ASSET',
    DELETE_ASSET: 'DELETE_ASSET',
    MOVE_ASSET_FORWARD: 'MOVE_ASSET_FORWARD',
    MOVE_ASSET_BACKWARD: 'MOVE_ASSET_BACKWARD',

    SET_ASSET_SIZE: 'SET_ASSET_SIZE',

    ADD_UNDO_STATE: 'ADD_UNDO_STATE',
    SEAL_UNDO_STATE: 'SEAL_UNDO_STATE',
    UNDO_STATE: 'UNDO_STATE',
    REDO_STATE: 'REDO_STATE',

    LOAD_NEWS_REQUEST: 'LOAD_NEWS_REQUEST',
    LOAD_NEWS_SUCCESS: 'LOAD_NEWS_SUCCESS',
    LOAD_NEWS_FAILURE: 'LOAD_NEWS_FAILURE',

    LOAD_WEATHER_REQUEST: 'LOAD_WEATHER_REQUEST',
    LOAD_WEATHER_SUCCESS: 'LOAD_WEATHER_SUCCESS',
    LOAD_WEATHER_FAILURE: 'LOAD_WEATHER_FAILURE',

    LOAD_STOCKS_REQUEST: 'LOAD_STOCKS_REQUEST',
    LOAD_STOCKS_SUCCESS: 'LOAD_STOCKS_SUCCESS',
    LOAD_STOCKS_FAILURE: 'LOAD_STOCKS_FAILURE',

    LOAD_FONTS_SUCCESS: 'LOAD_FONTS_SUCCESS',
    LOAD_CUSTOM_FONTS_SUCCESS: 'LOAD_CUSTOM_FONTS_SUCCESS',
};

export const showEditor = (payload: { themeId?: string; buildingId?: string; exitPath?: string }) => ({
    type: Actions.SHOW_EDITOR,
    payload,
});
export const editTheme = (payload: Theme, meta: { buildingId: string }) => ({
    type: Actions.EDIT_THEME,
    payload,
    meta,
});
export const hideEditor = () => ({
    type: Actions.HIDE_EDITOR,
});
export const hideEditorRequest = () => ({
    type: Actions.HIDE_EDITOR_REQUEST,
});

export const saveThemeRequest = () => ({
    type: Actions.SAVE_THEME_REQUEST,
});
export const saveThemeSuccess = ({ theme, buildingId }: any) => ({
    type: Actions.SAVE_THEME_SUCCESS,
    payload: { theme, buildingId },
});
export const saveThemeFailure = (errString: string) => ({
    type: Actions.SAVE_THEME_FAILURE,
    error: true,
    payload: errString,
});
export const dismissError = () => ({
    type: Actions.DISMISS_ERROR,
});
export const clearError = () => ({
    type: Actions.CLEAR_ERROR,
});
export const dismissPublishPending = () => ({
    type: Actions.DISMISS_PUBLISH_PENDING,
});

export const setActiveContainer = (id: string | null) => ({
    type: Actions.SET_ACTIVE_CONTAINER,
    payload: id,
});
export const setActiveAsset = (id: string) => ({
    type: Actions.SET_ACTIVE_ASSET,
    payload: id,
});

export const setZoomLevel = (zoom: number) => ({
    type: Actions.SET_ZOOM_LEVEL,
    payload: zoom,
});
export const setFitZoom = (fitZoom: number) => ({
    type: Actions.SET_FIT_ZOOM,
    payload: fitZoom,
});

export const setEditorThemeProperties = (payload: { displayName: string; width: number; height: number; requirements: Theme['requirements']; options: Theme['options'] }) => ({
    type: Actions.SET_EDITOR_THEME_PROPERTIES,
    payload,
});

export const setActiveRegion = ({ top, left, width, height }: any) => ({
    type: Actions.SET_ACTIVE_REGION,
    payload: { top, left, width, height },
});
export const clearActiveRegion = () => ({
    type: Actions.CLEAR_ACTIVE_REGION,
    payload: null,
});

export const previewNewContainer = ({ top, left, width, height }: any) => ({
    type: Actions.PREVIEW_NEW_CONTAINER,
    payload: { top, left, width, height },
});
export const addNewContainer = ({ container, assets = [] }: { container: Container; assets?: Asset[] }) => ({
    type: Actions.ADD_NEW_CONTAINER,
    payload: { container, assets },
});
export const updateContainer = (container: any) => ({
    type: Actions.UPDATE_CONTAINER,
    payload: container,
});
export const deleteContainer = (containerId: string) => ({
    type: Actions.DELETE_CONTAINER,
    payload: containerId,
});
export const moveContainerForward = (containerId: string) => ({
    type: Actions.MOVE_CONTAINER_FORWARD,
    payload: containerId,
});
export const moveContainerBackward = (containerId: string) => ({
    type: Actions.MOVE_CONTAINER_BACKWARD,
    payload: containerId,
});

export const uploadAssetRequest = ({ assetId, containerId, themeId, file, width, height }: { assetId: string; containerId: string; themeId: string; file: File; width: number; height: number }) => ({
    type: Actions.UPLOAD_ASSET_REQUEST,
    payload: { assetId, containerId, themeId, file, width, height },
});
export const uploadAssetProgress = ({ assetId, progress }: { assetId: string; progress: number }) => ({
    type: Actions.UPLOAD_ASSET_PROGRESS,
    payload: { assetId, progress },
});
export const uploadAssetSuccess = ({ assetId, filename }: { assetId: string; filename: string }) => ({
    type: Actions.UPLOAD_ASSET_SUCCESS,
    payload: { assetId, filename },
});
export const uploadAssetFailure = (error: string, meta: { assetId: string }) => ({
    type: Actions.UPLOAD_ASSET_FAILURE,
    error: true,
    payload: error,
    meta,
});
export const clearUploadAssetProgress = (assetId: string) => ({
    type: Actions.CLEAR_UPLOAD_ASSET_PROGRESS,
    payload: assetId,
});

export const addNewAsset = ({ asset, containerId }: { asset: Asset; containerId: string }) => ({
    type: Actions.ADD_NEW_ASSET,
    payload: { asset, containerId },
});
export const updateAsset = (asset: Asset) => ({
    type: Actions.UPDATE_ASSET,
    payload: asset,
});
export const deleteAsset = (assetId: string) => ({
    type: Actions.DELETE_ASSET,
    payload: assetId,
});
export const moveAssetForward = ({ assetId, containerId }: { assetId: string; containerId: string }) => ({
    type: Actions.MOVE_ASSET_FORWARD,
    payload: { assetId, containerId },
});
export const moveAssetBackward = ({ assetId, containerId }: { assetId: string; containerId: string }) => ({
    type: Actions.MOVE_ASSET_BACKWARD,
    payload: { assetId, containerId },
});

export const setAssetSize = (payload: { assetId: string; width: number; height: number }) => ({
    type: Actions.SET_ASSET_SIZE,
    payload,
});

export const addUndoState = (action: any) => ({
    type: Actions.ADD_UNDO_STATE,
    payload: action,
});
export const sealUndoState = () => ({
    type: Actions.SEAL_UNDO_STATE,
});
export const undoState = () => ({
    type: Actions.UNDO_STATE,
});
export const redoState = () => ({
    type: Actions.REDO_STATE,
});

export const loadNewsRequest = (channelId: string) => ({
    type: Actions.LOAD_NEWS_REQUEST,
    payload: channelId,
});
export const loadNewsSuccess = ({ channelId, news, updated }: { channelId: string; news: any[]; updated: number }) => ({
    type: Actions.LOAD_NEWS_SUCCESS,
    payload: news,
    meta: { channelId, updated },
});
export const loadNewsFailure = ({ channelId, err }: { channelId: string; err: Error }) => ({
    type: Actions.LOAD_NEWS_FAILURE,
    payload: err,
    error: true,
    meta: { channelId },
});

export const loadWeatherRequest = (payload: { provider: string; locationOrLatLong: string }) => ({
    type: Actions.LOAD_WEATHER_REQUEST,
    payload,
});
export const loadWeatherSuccess = (weather: any, meta: { provider: string; locationOrLatLong: string; updated: number }) => ({
    type: Actions.LOAD_WEATHER_SUCCESS,
    payload: weather,
    meta,
});
export const loadWeatherFailure = (error: string, meta: { provider: string; locationOrLatLong: string; updated: number }) => ({
    type: Actions.LOAD_WEATHER_FAILURE,
    payload: error,
    error: true,
    meta,
});

export const loadStocksRequest = (symbols: string, provider: string = 'default') => ({
    type: Actions.LOAD_STOCKS_REQUEST,
    payload: { symbols, provider },
});
export const loadStocksSuccess = ({ provider, symbols, stocks, updated }: { provider: string; symbols: string; stocks: any; updated: number }) => ({
    type: Actions.LOAD_STOCKS_SUCCESS,
    payload: stocks,
    meta: { provider, symbols, updated },
});
export const loadStocksFailure = (error: string, meta: { provider: string; symbols: string }) => ({
    type: Actions.LOAD_STOCKS_FAILURE,
    payload: error,
    error: true,
    meta,
});

export const loadFontsSuccess = (fonts: any[]) => ({
    type: Actions.LOAD_FONTS_SUCCESS,
    payload: fonts,
});

export const loadCustomFontsSuccess = (customFonts: string[]) => ({
    type: Actions.LOAD_CUSTOM_FONTS_SUCCESS,
    payload: customFonts,
});